import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import {
  Users,
  Award,
  Globe,
  TrendingUp,
  Shield,
  Target,
  Heart,
  Zap,
} from "lucide-react";
import "../../../assets/css/user/about/aboutUs.css";
import Navbar from "../../../components/user/navbar/Navbar";
import SimpleBanner from "../../../components/user/general/SimpleBanner";
import Footer from "../../../components/user/footer/Footer";
import MarqueeBanner from "../../../components/user/Marqueebanner/Marqueebanner";

const AboutUs = () => {
  const stats = [
    {
      id: 1,
      icon: Users,
      number: "10K+",
      label: "Active Users",
      color: "purple",
    },
    {
      id: 2,
      icon: Award,
      number: "500+",
      label: "Service Deals",
      color: "blue",
    },
    {
      id: 3,
      icon: Globe,
      number: "25K+",
      label: "Deals Completed",
      color: "orange",
    },
    {
      id: 4,
      icon: TrendingUp,
      number: "4.8",
      label: "Avg Rating",
      color: "green",
    },
  ];

  const values = [
    {
      id: 1,
      icon: Shield,
      title: "Trust & Safety",
      description: "We prioritize customer trust through secure transactions",
      color: "purple",
    },
    {
      id: 2,
      icon: Target,
      title: "Efficiency",
      description: "Streamlined processes to save time and resources",
      color: "blue",
    },
    {
      id: 3,
      icon: Heart,
      title: "Inclusivity",
      description:
        "Creating accessible platforms for diverse communities",
      color: "orange",
    },
    {
      id: 4,
      icon: Zap,
      title: "Growth",
      description: "Continuously evolving to deliver innovative solutions",
      color: "green",
    },
  ];

  return (
    <div className="about-us-container">
      <MarqueeBanner />
      <Navbar />

      <SimpleBanner
        title="About us"
        subtitle="Pakistan's first marketplace for instant deals."
        breadcrumbs={[
          { label: "Home", href: "/" },
          { label: "about us", href: "/about us" },
        ]}
      />

      <Container fluid className="mt-5">
        {/* Mission Section */}
        <Row className="mission-section">
          <Col lg={6} md={12} className="mission-content">
            <h2 className="section-title">Our Mission</h2>
            <p className="mission-text">
              We believe that every appointment our has value. When a customer
              cancels or a service provider has empty slots, those lost
              revenue and missed opportunities.
            </p>
            <p className="mission-text">
              Time4Pulse bridges the gap by enabling sellers or other
              appointment-based service providers in various sectors.
              Customers get amazing services at lower costs, and sellers
              recover cancellations with last-minute deals.
            </p>
          </Col>

          <Col lg={6} md={12} className="mission-image-col">
            <div className="mission-image-card">
              <div className="mission-icon-wrapper">
                <Zap size={48} />
              </div>
              <h3 className="mission-highlight-title">Zero Waste</h3>
              <p className="mission-highlight-text">
                No more wasted appointment time. Every slot is an opportunity!
              </p>
            </div>
          </Col>
        </Row>

        {/* Stats Section */}
        <div className="stats-section">
          <Row className="g-4">
            {stats.map((stat) => {
              const Icon = stat.icon;
              return (
                <Col lg={3} md={6} sm={6} xs={6} key={stat.id}>
                  <div className="stat-card">
                    <div className={`stat-icon-wrapper stat-${stat.color}`}>
                      <Icon size={28} />
                    </div>
                    <h3 className="stat-number">{stat.number}</h3>
                    <p className="stat-label">{stat.label}</p>
                  </div>
                </Col>
              );
            })}
          </Row>
        </div>

        {/* Values Section */}
        <div className="values-section">
          <h2 className="values-title">Our Values</h2>

          <Row className="g-4">
            {values.map((value) => {
              const Icon = value.icon;
              return (
                <Col lg={3} md={6} sm={6} key={value.id}>
                  <Card className="value-card">
                    <div
                      className={`value-icon-wrapper value-${value.color}`}
                    >
                      <Icon size={24} />
                    </div>
                    <h5 className="value-title">{value.title}</h5>
                    <p className="value-description">{value.description}</p>
                  </Card>
                </Col>
              );
            })}
          </Row>
        </div>
      </Container>

      <Footer />
    </div>
  );
};

export default AboutUs;